export default "__VITE_ASSET__aUvWCRev__"